import {ReactReduxContext, useDispatch, useSelector} from "react-redux";
import React, {useContext} from "react";
import {setFormData} from "../../actions";
import FORM_DATA from "../steps/bi/constants/FORM_DATA";

/**
 * Represents a dropdown component for Step 3 of a form, which maintains state of
 * campus/housing in complete form.
 *
 * @param {Object} Step3DropDown - The component props.
 * @param {string} Step3DropDown.elementName - The unique name/id of the dropdown element.
 * @param {string} Step3DropDown.dataSource - The source of the dropdown options.
 * @param {string} Step3DropDown.labelText - The label text for the dropdown.
 * @returns {React.Component} - Step 3 Campus/Housing select component.
 */
export const Step3DropDown = ({elementName, dataSource, labelText}) => {
    const dispatch = useDispatch();
    const context = useContext(ReactReduxContext);
    const data = () => context.store.getState().app.stepData.step2[elementName];
    const val = useSelector(data);
    const source = FORM_DATA[dataSource];

    return (
        <div className="selectBox">
            <label htmlFor={elementName}>{labelText}</label>
            <select
                aria-required={true}
                id={elementName}
                name={elementName}
                value={val}
                onChange={(e) => {
                    e.preventDefault();
                    let v = {};
                    v[elementName] = parseInt(e.target.value);
                    dispatch(setFormData(2, v));
                }}
            >
                {
                    source.map((option, index) => (
                        option.value > 0 && <option key={index} value={option.value}>{option.text}</option>
                    ))
                }
            </select>
        </div>
    )
}